export const dateEnLocale = {
  'date.range.from': 'From',
  'date.range.to': 'to',
  'date.range.and': 'and',
  'date.range.yearSuffix': 'of {year}',
  'date.range.of': 'of',
  'date.range.at': 'at',
} as const;

export const dateEsLocale = {
  'date.range.from': 'Desde',
  'date.range.to': 'hasta',
  'date.range.and': 'y',
  'date.range.yearSuffix': 'de {year}',
  'date.range.of': 'de',
  'date.range.at': 'a las',
} as const;
